import { DEFAULT_TEAM_MEETING_SETTINGS } from "src/components";
import { useSettings, type IMetricsSettings, type ITeamMeetingSettings, type ITeamStrategySettings } from "src/hooks";

const useTeamMeetingSettings = (teamSlug: string) => {
  const {
    teamMeetingSettings: { [teamSlug]: unsafeSettings },
    updateTeamMeetingSettings,
  } = useSettings();

  const safeSettings: ITeamMeetingSettings = {
    ...DEFAULT_TEAM_MEETING_SETTINGS,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateMetricSettings: (updatedSettings: Partial<IMetricsSettings>) => {
      updateTeamMeetingSettings(teamSlug, {
        ...safeSettings,
        metrics: {
          ...safeSettings.metrics,
          ...updatedSettings,
        },
      });
    },
    updateStrategySettings: (updatedSettings: Partial<ITeamStrategySettings>) => {
      updateTeamMeetingSettings(teamSlug, {
        ...safeSettings,
        strategy: {
          ...safeSettings.strategy,
          ...updatedSettings,
        },
      });
    },
  };
};

export { useTeamMeetingSettings };
